/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";
import { Logger } from "cms/utils/logger";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { setOrgSettings } from "cms/store/reducers/orgSettings/orgSettings.slice";
import { dispatch } from "cms/store/index";

const useFetchWebsite = (props) => {

    const setError = props?.setError;
    const setWebsite = props?.setWebsite;
    const setSettings = props?.setSettings;

    const { token } = useAuth();

    async function fetchWebsiteData (token) {
        try {

            const domain = window.location.host;
            Logger.debug(`Using domain: ${domain}`);
            const website = await SimpliCitySDK.website.findForDomain(token, encodeURIComponent(domain));
            const organization = website?.organization;

            // get and add org settings to context and store
            const settings = await SimpliCitySDK.orgSetting.find(token, organization);
            setSettings(settings);
            dispatch(setOrgSettings(settings));
            // console.info(`Loaded Settings.`, settings);

            // and website to context
            // ... website must come last here in order to provide settings
            setWebsite(website);

        } catch (error) {
            console.error("Failed to load website data.", error);
            Logger.error("Failed to load website data.", error);
            setError({ message: "Failed to load website data.", error: error });
        }
    }
    useEffect(() => {
        fetchWebsiteData(token);
        // eslint-disable-next-line
    }, [token])
};

export { useFetchWebsite };
